export default [{
        path: '/dataList/paperTable',
        component: resolve => require(['../page.vue'], resolve),
        meta: {
            title: '纸质修护',
            authLogin: true
        }
    },
    {
        path: '/collectMoney/paperTable/edit',
        component: resolve => require(['../edit.vue'], resolve),
        meta: {
            title: '纸质修护卡编辑',
            authLogin: true
        }
    },
    {
        path: '/collectMoney/paperTable/detail/:id',
        component: resolve => require(['../detail.vue'], resolve),
        meta: {
            title: '纸质修护卡详情',
            authLogin: true
        }
    },
]